package com.example.readingnotes.domain.model

data class TotpSetupResponse(
    val secret: String,
    val qrCodeUrl: String,
)
